// extracted by mini-css-extract-plugin
module.exports = {"clearBtn":"ProposeResourcesPopup_clearBtn__z-pxk"};